import { render, staticRenderFns } from "./BookingPlaceInformation.vue?vue&type=template&id=103473da"
import script from "./BookingPlaceInformation.vue?vue&type=script&lang=js"
export * from "./BookingPlaceInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports